import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaUser } from 'react-icons/fa';
import useAuth from '../../composant_reutilisable/useAuth';
import Navbar from '../../composant_reutilisable/navbar';
import Sidebar from '../../composant_reutilisable/sidebar';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import Footer from '../../composant_reutilisable/footer';

const ProfilAdministrateur = ({ titre }) => {
    useAuth(); // Vérifier l'authentification
    const navigate = useNavigate();
    const user_id = localStorage.getItem('userId');

    useEffect(() => {
        if (user_id) {
            document.title = "Showtime | Profil";
        }
    }, [user_id]);

    const [userData, setUserData] = useState({
        email: '',
        nom: '',
        prenoms: '',
        telephone: '',
        mdp: '',
        mdp1: '',
        mdp2: '',
    });

    const [initialUserData, setInitialUserData] = useState(userData);
    const [message, setMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [messageType, setMessageType] = useState('success'); // ou 'danger'


    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/api/recup-info-profil/${user_id}/`);
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
                setInitialUserData(data);
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };
        fetchUserData();
    }, [user_id]);

    const handleChange = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        });
    };

    // const handlePhoneChange = (value) => {
    //     setUserData({
    //         ...userData,
    //         telephone: value,
    //     });
    // };

    const handlePhoneChange = (value, countryData) => {
        if (value.startsWith("229")) {
            let localNumber = value.slice(3); // Supprime l'indicatif "229"

            // Si le numéro ne commence pas par "01", on l'ajoute
            if (!localNumber.startsWith("01")) {
                localNumber = "01" + localNumber.replace(/^0+/, ""); // évite les zéros en trop
            }

            // Ne garder que 10 chiffres (01 + 8 chiffres)
            if (localNumber.length > 10) {
                localNumber = localNumber.slice(0, 10);
            }

            const finalValue = "229" + localNumber;

            setUserData((prev) => ({ ...prev, telephone: finalValue }));
        } else {
            setUserData((prev) => ({ ...prev, telephone: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${user_id}/`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(userData)
            });

            const data = await response.json();
            // console.log("Réponse du backend :", data); // Debug

            if (response.ok) {

                setMessage('Profil mis à jour avec succès.');
                setMessageType('success');
                setShowMessage(true);
                setTimeout(() => {
                    setShowMessage(false);
                    navigate(`/Mon-Profil`);
                }, 3000);
            } else {
                setMessage(data.message || "Erreur lors de la mise à jour du profil.");
                setMessageType('danger');
                setShowMessage(true);
            }
        } catch (error) {
            console.error('Erreur lors de la mise à jour:', error);
            setMessage("Une erreur réseau est survenue.");
            setMessageType('danger');
            setShowMessage(true);
        }
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-profil-utilisateur/${user_id}/`, {
    //             method: 'PUT',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(userData)
    //         });

    //         const data = await response.json();
    //         console.log("Réponse du backend :", data); // Debug

    //         if (response.ok) {
    //             // Succès
    //             setMessage("✅ " + (data.message || 'Profil mis à jour avec succès.'));
    //             setShowMessage(true);
    //             setTimeout(() => {
    //                 setShowMessage(false);
    //                 navigate(`/Mon-Profil`);
    //             }, 3000);
    //         } else {
    //             // Erreur côté backend
    //             setMessage("❌ " + (data.message || "Une erreur est survenue lors de la mise à jour."));
    //             setShowMessage(true);
    //         }
    //     } catch (error) {
    //         // Erreur réseau ou autre exception
    //         console.error('Erreur lors de la mise à jour:', error);
    //         setMessage("❌ Une erreur réseau est survenue.");
    //         setShowMessage(true);
    //     }
    // };


    const handleReset = () => {
        setUserData(initialUserData);
    };

    const [showPassword, setShowPassword] = useState({
        mdp: false,
        mdp1: false,
        mdp2: false,
    });

    const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const renderPasswordField = (label, name) => (
        <Col md={4}>
            <Form.Group className="mb-3" controlId={name}>
                <Form.Label>{label}</Form.Label>
                <div style={{ position: "relative" }}>
                    <Form.Control
                        type={showPassword[name] ? "text" : "password"}
                        name={name}
                        value={userData[name]}
                        onChange={handleChange}
                        className="custom-input"
                    />
                    <span
                        onClick={() => togglePasswordVisibility(name)}
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#6c757d",
                        }}
                    >
                        {showPassword[name] ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>
            </Form.Group>
        </Col>
    );

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar user_id={user_id} />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className='d-flex align-items-center'><FaUser size={25} className='mr-2' />Mon profil</h2>
                        <small>Ici vous pouvez consulter ou modifier vos informations.</small>

                        <small id='hbreadcrumb' className='d-flex justify-content-end'>
                            <ol className="breadcrumb custom-breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={`/Dashboard`}>Accueil</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    Mon profil
                                </li>
                            </ol>
                        </small>
                    </div>
                </div>
                <div className="container wrapper wrapper-content animated fadeInRight mt-5">
                    <div className="row">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            {/* <h3>Informations d'identité</h3> */}
                            {showMessage && (
                                <Alert variant={messageType} onClose={() => setShowMessage(false)}>
                                    {message}
                                </Alert>
                            )}
                            <div className="hpanel mb-5">
                                <div className="panel-body styled-panel">
                                    <div className="mb-4 text-center">
                                        <i className="fa fa-user-circle login-logo" style={{ fontSize: '50px' }}></i>
                                    </div>
                                    <h3 className="font-bold text-center">Consultez votre profil</h3>
                                    <Form onSubmit={handleSubmit} className="reg-page">
                                        <Row>

                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="nom">
                                                    <Form.Label>Nom</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="nom"
                                                        value={userData.nom}
                                                        onChange={handleChange}
                                                        className="custom-input"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="prenoms">
                                                    <Form.Label>Prénoms</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="prenoms"
                                                        value={userData.prenoms}
                                                        onChange={handleChange}
                                                        className="custom-input"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="email">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        placeholder={userData.email}
                                                        readOnly
                                                        className="custom-input"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="telephone">
                                                    <Form.Label>Téléphone</Form.Label>
                                                    <PhoneInput
                                                        name="telephone"
                                                        //className="form-control"
                                                        value={userData.telephone}
                                                        onChange={handlePhoneChange}
                                                        required
                                                        placeholder="XXXX XXXX"
                                                        inputStyle={{
                                                            width: "100%",
                                                            height: "33px",
                                                            fontSize: "12px",
                                                            paddingLeft: "55px"
                                                        }}
                                                        containerStyle={{ width: "100%" }}
                                                        inputProps={{
                                                            name: "telephone",
                                                            required: true,
                                                        }}
                                                        dropdownStyle={{
                                                            maxHeight: "135px",
                                                            overflowY: "auto",
                                                            zIndex: 1050,
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <>
                                                {renderPasswordField("Ancien mot de passe", "mdp")}
                                                {renderPasswordField("Nouveau mot de passe", "mdp1")}
                                                {renderPasswordField("Confirmer le nouveau mot de passe", "mdp2")}
                                            </>
                                        </Row>

                                        <div className="text-center">
                                            <Button type="button" variant="default" onClick={handleReset}>
                                                <strong>Annuler</strong>

                                            </Button>
                                            <Button type="submit" variant="success" className="ml-2">
                                                <strong>Modifier</strong>

                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-2"></div>
                    </div>
                </div>

                <div className="footer text-center">
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default ProfilAdministrateur;
